import script from "./NotificationIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__